
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from './App.tsx'
import './index.css'
import { getAuthConfig } from './lib/auth.ts'

// Create a client
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <Auth0Provider
    {...getAuthConfig()}
  >
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </Auth0Provider>
);
